import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { env } from '@/lib/env'
import { readPreferences, writePreferences } from '@/lib/auth/session-store'
import { setDayjsLocale } from '@/lib/format'

import { en, type TranslationShape } from './locales/en'
import { pt } from './locales/pt'

export type SupportedLanguage = 'pt' | 'en'

const stored = readPreferences().language
const initialLanguage: SupportedLanguage =
  stored === 'pt' || stored === 'en'
    ? stored
    : (env.defaultLocale as SupportedLanguage)

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    pt: { translation: pt },
  },
  lng: initialLanguage,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnNull: false,
})

export async function setLanguage(language: SupportedLanguage): Promise<void> {
  writePreferences({ language })
  document.documentElement.lang = language
  setDayjsLocale(language)
  await i18n.changeLanguage(language)
}

document.documentElement.lang = initialLanguage
setDayjsLocale(initialLanguage)

declare module 'i18next' {
  interface CustomTypeOptions {
    resources: { translation: TranslationShape }
  }
}

export default i18n
